export default "__VITE_ASSET__Dsa1s$yA__"